module.exports = __webpack_public_path__ + "static/media/arcor.ee645dc0.png";